
import React, { useState, useRef, useEffect } from 'react'
import Icons from '../Images'
import Config from './../../Config'
const { platform } = Config()

export default function Input(property) {
    const [isFocus, setStatus] = useState(false)


    const inputRef = useRef(null);

    const handleClick = () => {
        inputRef.current.focus();
    };


    const changeInputStatus = (isFocus) => {
        setStatus(isFocus)
    }


    useEffect(() => {
        // 在组件挂载后自动调用 handleClick
        if (property?.platform == 'Mobile' && !property?.fromPage) {
            handleClick();
        }
    }, []);

    return <div
        className='textInputBox'
        style={{ ...property.style, borderColor: isFocus ? '#00A6FF' : '#E3E3E3' }}
    >
        <input
            type="search"
            placeholder={property?.tempText?.text4}
            ref={inputRef}
            placeholderTextColor={'gray'}
            {...property}
            tempText={null}
            onFocus={() => {
                changeInputStatus(true)
                typeof property?.onFocus == 'function' && property?.onFocus()
            }}
            onBlur={() => {
                changeInputStatus(false)
                typeof property?.onFocus == 'function' && property?.onBlur()
            }}
            className="textInput"
        ></input>

        <img
            src={Icons.search}
            className="searchInputIcon"
            onClick={() => {
                platform == 'Web' && property?.onImgClick()
                // 可以看看这个问题吗？ user说 他们需要click enter才可以
            }}
        ></img>
    </div>
}